//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const setPlacenetExamList = (returnedPayload) => ({ type: ActionTypes.exams.set_placement_exam_list , payload: returnedPayload  });
export const updatePlacementExamList = (returnedPayload) => ({ type: ActionTypes.exams.update_placement_exam_list, payload: returnedPayload });



export const setPlacementExamSubmissionsByCode = (returnedPayload) => ({ type: ActionTypes.exams.set_placement_submission_by_exam , payload: returnedPayload });

export const setPlacementExamSession = (returnedPayload) => ({ type: ActionTypes.exams.set_placement_session , payload: returnedPayload });
export const setPlacementResumeExamSession = (returnedPayload) => ({ type: ActionTypes.exams.set_placement_resume_session , payload: returnedPayload });
export const updatePlacementExamSession = (returnedPayload) => ({ type: ActionTypes.exams.update_placement_session, payload: returnedPayload });
export const clearPlacementExmaSession = () => ({ type: ActionTypes.exams.clear_placement_session });


export const setPlacementExamDistrictAssignment = (returnedPayload) => ({ type: ActionTypes.exams.set_placement_exam_distict_assignment , payload: returnedPayload });


export const setPlacememntOrgConfig = (returnedPayload) => ({ type: ActionTypes.exams.set_placement_exam_org_config , payload: returnedPayload });






//  -- List logs ----------------

